/**
 * Now, re-read every thirty seconds, for the clock in the top bar.
 *
 * THIRTY SECONDS AND NOT ONE. The bar prints hours and minutes, so a tick a second would
 * re-render the shell sixty times for every change anybody can see; thirty keeps the minute
 * at most half a minute late, which nobody at a counter will ever catch it being.
 *
 * A TIMESTAMP AND NOT A STRING, so the caller formats it in the business's zone with the
 * same helpers every other time on the page goes through. A clock formatted here would be a
 * second place the "whose clock is it" rule lives. See the header of `format.ts`.
 */

import { useEffect, useState } from "react";

const TICK_MS = 30_000;

export function useClock(): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), TICK_MS);
    return () => clearInterval(timer);
  }, []);
  return now;
}
